<template>
    <div>

         <CustomModal v-if="isModalOpen" ref="customModal" :modalId="modalId" :isOpen="isModalOpen" :showFooter="true" @modalClosed="modalClosed" :isStyle="'max-width:100% !important;'">
            
            <template #header>
                <h5 class="modal-title">{{['create','transfer'].includes(action) ? $t('create_payment') : $t('edit_payment') }}</h5>
                <button type="button" id="close-modal-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="modalClosed"></button>
            </template>

            <template #body>
                <div class="payment-form">
                    
                        <div v-if="validationErrors.length" class="alert alert-danger" role="alert">
                            <ul class="mb-0">
                                <li v-for="(error, index) in validationErrors" :key="index">{{ error }}</li>
                            </ul>
                        </div>

                        <div class="row mb-4" v-if="!hideTypeToggle">
                            <div class="col-sm-12">
                                <div class="payment-type-toggle">
                                    <div class="toggle-container" :style="action === 'update' ? 'pointer-events: none; opacity: 0.7;' : ''">
                                        <div class="toggle-option" :class="{ active: isIncoming }" @click="action === 'update' ? null : isIncoming = true">
                                            <AppIcon name="bi-arrow-down-circle-fill" class="bi bi-arrow-down-circle-fill" />
                                            <span>{{$t('revenue')}}</span>
                                        </div>
                                        <div class="toggle-option" :class="{ active: !isIncoming }" @click="action === 'update' ? null : isIncoming = false">
                                            <AppIcon name="bi-arrow-up-circle-fill" class="bi bi-arrow-up-circle-fill" />
                                            <span>{{$t('expense')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!hidePaymentAssociations" class="row">

                            <div class="col-sm-3">
                                <div class="mb-3">
                                    <label for="paymentTypeSelect" class="form-label">{{$t('payment_type')}}</label>
                                    <select v-model="paymentType" @change="onPaymentTypeChange" class="form-select form-select-sm" id="paymentTypeSelect" :disabled="action === 'update' || localData.lock_invoice_payment">
                                        <option value="others">{{$t('others')}}</option>
                                        <option v-if="(isIncoming && isClientEnabled) || (!isIncoming && isSupplierEnabled)" value="invoice">{{$t('invoice')}}</option>
                                        <option value="project">{{$t('project')}}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="isIncoming === false && !isProjectPayment && paymentType === 'invoice' && isSupplierEnabled" class="col-sm-3">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('supplier_invoice')}}</label>
                                     <auto-complete 
                                        entity="supplier-invoices"
                                        emitEvent="emitAutoCompleteSupplierInvoice"
                                        :disabled="action === 'update' || !!localData?.supplierInvoice?.id"
                                        v-if="!modalIsLoading" 
                                        :defaultValue="localData?.supplierInvoice?.reference" 
                                        @emitAutoCompleteSupplierInvoice="emitAutoCompleteSupplierInvoice">
                                    </auto-complete>
                                </div>
                            </div>

                            <div v-if="!isProjectPayment && paymentType === 'project'" class="col-sm-3">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('project')}}</label>
                                     <auto-complete 
                                        entity="projects"
                                        emitEvent="emitAutoCompleteProject"
                                        :disabled="action === 'update'"
                                        v-if="!modalIsLoading" 
                                        :defaultValue="localData?.project?.name" 
                                        @emitAutoCompleteProject="emitAutoCompleteProject">
                                    </auto-complete>
                                </div>
                            </div>

                            <!-- <div v-if="isIncoming === false" class="col-sm-3">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('purchase')}}</label>
                                     <auto-complete 
                                        entity="purchases"
                                        :disabled="true"
                                        emitEvent="emitAutoCompletePurchase"
                                        v-if="!modalIsLoading" 
                                        :defaultValue="localData?.purchase?.reference" 
                                        @emitAutoCompletePurchase="emitAutoCompletePurchase">
                                    </auto-complete>
                                </div>
                            </div> -->

                            
                            <div v-if="isIncoming === true && !isProjectPayment && paymentType === 'invoice' && isClientEnabled" class="col-sm-3">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('invoice')}}</label>
                                     <auto-complete 
                                        entity="invoices"
                                        emitEvent="emitAutoCompleteInvoice"
                                        :disabled="action === 'update' || !!localData?.invoice?.id"
                                        v-if="!modalIsLoading" 
                                        :defaultValue="localData?.invoice?.reference" 
                                        @emitAutoCompleteInvoice="emitAutoCompleteInvoice">
                                    </auto-complete>
                                </div>
                            </div>

                            <!-- <div v-if="isIncoming === true" class="col-sm-3">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('order')}}</label>
                                     <auto-complete 
                                        entity="orders"
                                        emitEvent="emitAutoCompleteOrder"
                                        :disabled="true"
                                        v-if="!modalIsLoading" 
                                        :defaultValue="localData?.order?.reference" 
                                        @emitAutoCompleteOrder="emitAutoCompleteOrder">
                                    </auto-complete>
                                </div>
                            </div> -->

                        </div>

                        <hr>

                        <div class="row mb-2" v-if="localData?.supplierInvoice || localData?.invoice">
                            <label for="exampleFormControlInput1" class="form-label"><b>{{$t('invoice_informations')}}</b></label>
                            
                            <div class="col-sm-12" v-if="localData?.supplierInvoice">
                                <div class="" id="invoiceDate">{{$t('reference')}}: {{ localData?.supplierInvoice?.reference }}</div>
                            </div>

                            <div class="col-sm-12" v-if="localData?.invoice">
                                <div class="" id="invoiceDate">{{$t('reference')}}: {{ localData?.invoice?.reference }}</div>
                            </div>

                            <div class="col-sm-12" v-if="localData?.supplierInvoice">
                                <div class="" id="invoiceDate">{{$t('date')}}: {{ formatDate(localData?.supplierInvoice?.date) }}</div>
                            </div>

                            <div class="col-sm-12" v-if="localData?.invoice">
                                <div class="" id="invoiceDate">{{$t('date')}}: {{ formatDate(localData?.invoice?.date) }}</div>
                            </div>

                            <div class="col-sm-12" v-if="localData?.supplierInvoice">
                                <div class="" id="invoiceDate">{{$t('status')}}: {{ (localData?.supplierInvoice?.status) }}</div>
                            </div>

                            <div class="col-sm-12" v-if="localData?.invoice">
                                <div class="" id="invoiceDate">{{$t('status')}}: {{ (localData?.invoice?.status) }}</div>
                            </div>

                            <div class="col-sm-12">
                                <div class="" id="invoiceTotal">{{$t('total')}}: <b>{{ formatMoney(localData?.total) }} </b>  </div>
                            </div>
                            

                        </div>

                        <div
                            class="row g-3 mb-4 payment-fields"
                            :class="{ 'payment-fields--standalone': hidePaymentAssociations }"
                        >
                        
                            <div class="table-responsive mb-4" v-if="localData.transactions">
                                <label for="exampleFormControlInput1" class="form-label"><b>{{$t('payments_history')}}</b></label>
                                <div v-if="!localData.transactions.length">{{$t('no_payment_found')}}</div>
                                <table v-else class="table mb-0 table-borderless table-striped small">
                                    <thead>
                                        <tr class="text-secondary">
                                            <th class="pt-4 pb-3 px-6">{{$t('reference')}}</th>
                                            <th class="pt-4 pb-3 px-6">{{$t('amount')}}</th>
                                            <th class="pt-4 pb-3 px-6">{{$t('payment_method')}}</th>
                                            <th class="pt-4 pb-3 px-6">{{$t('status')}}</th>
                                            <th class="pt-4 pb-3 px-6">{{$t('created_at')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    <tr v-for="transaction in localData.transactions" :key="transaction.id">
                                        <td class="py-5 px-6">{{transaction.reference}}</td>
                                        <td class="py-5 px-6">{{formatMoney(transaction.amount)}}</td>
                                        <td class="py-5 px-6">{{$t(transaction.payment_method)}}</td>
                                        <td class="py-5 px-6">{{$t(transaction.status)}}</td>
                                        <td class="py-5 px-6">{{formatDate(transaction.created_at)}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <hr class="mt-4" v-if="localData.transactions">

                            <div class="col-sm-2 payment-field">
                                <label for="amountPaidInput" class="form-label">{{$t('amount_paid')}}</label>
                                <input v-model="amount_paid" type="number" class="form-control" id="amountPaidInput" min="0" :max="localData.maximum_amount || null" step="0.01" inputmode="decimal" :disabled="action === 'update' || localData.lock_payment_amount">
                            </div>

                            <div v-if="!hideInvoiceDetailFields" class="col-sm-2 payment-field">
                                <label for="paymentCategorySelect" class="form-label">
                                    {{$t('category')}} · {{$t(isIncoming ? 'revenue' : 'expense')}}
                                </label>
                                <div class="input-group">
                                    <select
                                        id="paymentCategorySelect"
                                        v-model="localData.category_id"
                                        class="form-select"
                                        :disabled="loadingCategories"
                                    >
                                        <option :value="null">{{$t('uncategorized')}}</option>
                                        <option v-for="category in categories" :key="category.id" :value="category.id">
                                            {{category.name}}
                                        </option>
                                    </select>
                                    <button
                                        v-if="canCreateCategories"
                                        type="button"
                                        class="btn btn-outline-secondary"
                                        :title="$t('add_category')"
                                        @click="showNewCategoryInput = !showNewCategoryInput"
                                    >
                                        <AppIcon name="bi-plus-lg" class="bi bi-plus-lg" />
                                    </button>
                                </div>
                                <div v-if="showNewCategoryInput" class="input-group input-group-sm mt-2">
                                    <input
                                        v-model.trim="newCategoryName"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('category_name')"
                                        maxlength="100"
                                        @keyup.enter="createCategory"
                                    >
                                    <button
                                        type="button"
                                        class="btn btn-success"
                                        :disabled="creatingCategory || newCategoryName.length < 2"
                                        @click="createCategory"
                                    >
                                        <AppIcon name="bi-check-lg" class="bi bi-check-lg" />
                                    </button>
                                </div>
                            </div>

                            <div class="col-sm-2 payment-field">
                                <label for="paymentMethodSelect" class="form-label">{{$t('payment_method')}}</label>
                                    <select id="paymentMethodSelect" v-if="!loadingPaymentMethods" v-model="localData.payment_method" class="form-select" :key="activePaymentMethods.length">
                                    <option v-for="method in activePaymentMethods" :key="method.id || method.name" :value="method.slug">
                                        {{ method.name }}
                                    </option>
                                </select>
                                <div v-else class="form-control">
                                    <small class="text-muted">{{ $t('loading') }}...</small>
                                </div>
                            </div>
                            <div class="col-sm-2 payment-field" v-if="localData.payment_method == 'cheque'">
                                <label for="paymentReferenceInput" class="form-label">{{$t('transaction_id')}}</label>
                                <input id="paymentReferenceInput" v-model="localData.pm_reference" type="text" class="form-control">
                            </div>

                            <div class="col-sm-2 payment-field">
                                <label for="paymentDateInput" class="form-label">{{$t('date')}}</label>
                                <input
                                    id="paymentDateInput"
                                    v-model="localData.date"
                                    type="date"
                                    class="form-control"
                                >
                            </div>

                            <div v-if="!hidePaymentAssociations" class="col-sm-2 payment-field">
                                <label for="paymentDueDateInput" class="form-label">{{$t('due_date')}}</label>
                                <input
                                    id="paymentDueDateInput"
                                    v-model="localData.due_date"
                                    type="date"
                                    class="form-control"
                                >
                            </div>

                            <div class="col-sm-2 payment-field" v-if="!hideInvoiceDetailFields && !hidePaymentAssociations && isIncoming === true && isClientEnabled">
                                <label class="form-label">{{$t('client')}}</label>
                                <auto-complete
                                    v-if="!modalIsLoading"
                                    @emitAutoCompleteClient="emitAutoCompleteClient"
                                    :defaultValue="localData?.client?.name"
                                    entity="clients"
                                    :disabled="action === 'update' || !!localData?.client?.id"
                                    emitEvent="emitAutoCompleteClient"
                                ></auto-complete>
                            </div>

                            <div class="col-sm-2 payment-field" v-if="!hidePaymentAssociations && isIncoming === false && isSupplierEnabled">
                                <label class="form-label">{{$t('supplier')}}</label>
                                <auto-complete
                                    v-if="!modalIsLoading"
                                    @emitAutoCompleteSupplier="emitAutoCompleteSupplier"
                                    :defaultValue="localData?.supplier?.name"
                                    entity="suppliers"
                                    :disabled="action === 'update' || !!localData?.supplier?.id"
                                    emitEvent="emitAutoCompleteSupplier"
                                ></auto-complete>
                            </div>

                            <div v-if="!hidePaymentAssociations" class="col-sm-2 payment-field">
                                <label for="paymentStatusSelect" class="form-label">{{$t('status')}}</label>
                                <select id="paymentStatusSelect" v-model="localData.status" class="form-select" :disabled="localData.lock_invoice_payment">
                                    <option value="paid">{{$t('paid')}}</option>
                                    <option value="pending">{{$t('pending')}}</option>
                                    <option value="failed">{{$t('failed')}}</option>
                                    <option value="refunded">{{$t('refunded')}}</option>
                                    <option value="canceled">{{$t('canceled')}}</option>
                                </select>
                            </div>

                            <div v-if="!hidePaymentAssociations" class="col-sm-2 payment-field">
                                <label for="amountPaidInput" class="form-label" style="">{{$t('balance_due')}}</label>
                                <div class="p-1" style="font-size:18px;font-weight:bold">{{ formatMoney(balanceDue) }}</div>
                            </div>

                        </div>


                        <!-- Attachments Section -->
                        <div class="mb-3">
                            <div 
                                class="attachment-dropzone"
                                :class="{ 'dropzone-active': isDragging }"
                                role="button"
                                tabindex="0"
                                :aria-label="$t('attachments')"
                                @dragover.prevent="isDragging = true"
                                @dragleave.prevent="isDragging = false"
                                @drop.prevent="handleDrop"
                                @click="$refs.fileInput.click()"
                                @keydown.enter.prevent="$refs.fileInput.click()"
                                @keydown.space.prevent="$refs.fileInput.click()"
                            >
                                <input type="file" ref="fileInput" @change="handleFileSelect" multiple style="display: none;">
                                <div class="dropzone-content">
                                    <AppIcon name="bi-paperclip" class="bi bi-paperclip dropzone-icon" />
                                    <div class="dropzone-copy">
                                        <span class="dropzone-title">{{$t('attachments')}}</span>
                                        <small class="text-muted">{{$t('drag_drop_file')}} · {{$t('or_click_to_browse')}}</small>
                                    </div>
                                    <span v-if="selectedFiles.length" class="badge bg-primary rounded-pill">{{ selectedFiles.length }}</span>
                                    <AppIcon name="bi-cloud-arrow-up" class="bi bi-cloud-arrow-up upload-icon" />
                                </div>
                            </div>
                            <div v-if="selectedFiles.length" class="attachment-list mt-2">
                                <div v-for="(file, index) in selectedFiles" :key="index" class="attachment-item">
                                    <div class="d-flex align-items-center gap-2 overflow-hidden">
                                        <div class="attachment-icon-wrapper">
                                            <AppIcon :name="getFileIcon(file.name)" :class="getFileIcon(file.name)" class="attachment-file-icon" />
                                        </div>
                                        <div class="overflow-hidden">
                                            <div class="attachment-filename text-truncate">{{ file.name }}</div>
                                            <small class="text-muted">{{ formatFileSize(file.size) }}</small>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-sm attachment-remove-btn" @click.stop="removeFile(index)">
                                        <AppIcon name="bi-trash3" class="bi bi-trash3" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="mb-3">
                            
                            <span v-if="checkIfValidProduct()" @click="invoiceModalisOpen = true" style="cursor:pointer">
                                <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                <small>&nbsp;{{$t('preview')}}</small>
                            </span>
                            
                        </div> -->

                        <!-- Notes Section -->
                        <div class="mb-3">
                            <collapsible-notes-field v-model="localData.notes" id="payment-notes" rows="1" />
                        </div>

                    </div>
            </template>

            <template #footer>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button v-if="action == 'update'" type="button" class="btn btn-success" @click="updateRow" :disabled="loading"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('save')}}</button>
                <button v-if="['create','transfer'].includes(action)" type="button" class="btn btn-success" @click="saveRow" :disabled="loading || !isRequestedInvoicePaymentValid"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
            </template>

        </CustomModal>


        <div v-if="createSupplierState">
            <add-supplier :state="createSupplierState" @createSupplier="createSupplier"/>
        </div>
        
        <!-- invoice modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-payment-modal-22" 
            :isModalOpen="invoiceModalisOpen"  
            :data="data" 
            type="payment">
        </invoice-template-modal>
        <!-- invoice modal -->

    </div>
   
    
    
</template>

<script>
import CustomModal from '../CustomModal.vue'
import helper from '../../helper'
import AutoComplete from '../autocomplete/AutoComplete'
import AddSupplier from '../AddSupplier.vue'
import InvoiceTemplateModal from '../invoiceLayout/InvoiceTemplateModal.vue'
import moment from 'moment'
import { getDefaultPaymentMethods } from '../../constants/paymentMethods'
export default {
  name: 'AddEditPaymentModal',
  props : {
        action: {
            type: String,
            required: true
        },
        data: {
            default: false
        },
        isModalOpen: {
            type: Boolean,
            default: false
        },
        hidePaymentAssociations: {
            type: Boolean,
            default: false
        },
        hideInvoiceDetailFields: {
            type: Boolean,
            default: false
        },
        modalId : {
            type : String,
            default : 'exampleModal'
        }
    },
  components : {
    CustomModal,
    AutoComplete,
    AddSupplier,
    InvoiceTemplateModal
  },
  data(){
    const parsedData = this.data ? JSON.parse(JSON.stringify(this.data)) : {}
    // Ensure payment_method exists for Vue reactivity
    if (!parsedData.payment_method) {
      parsedData.payment_method = ''
    }
    if (parsedData.category_id === undefined) {
      parsedData.category_id = null
    }

    if (parsedData.invoice) {
      if (parsedData.total === undefined || parsedData.total === null || parsedData.total === 0) {
        parsedData.total = parsedData.invoice.total;
      }
      if (!parsedData.transactions || parsedData.transactions.length === 0) {
        parsedData.transactions = parsedData.invoice.transactions;
      }
    }
    if (parsedData.supplierInvoice) {
      if (parsedData.total === undefined || parsedData.total === null || parsedData.total === 0) {
        parsedData.total = parsedData.supplierInvoice.total;
      }
      if (!parsedData.transactions || parsedData.transactions.length === 0) {
        parsedData.transactions = parsedData.supplierInvoice.transactions;
      }
    }

    let isIncoming = true;
    if (parsedData.type === 'expense' || parsedData.is_incoming === false || parsedData.is_incoming === 0) {
        isIncoming = false;
    } else if (parsedData.type === 'revenue' || parsedData.is_incoming === true || parsedData.is_incoming === 1) {
        isIncoming = true;
    }

    let amount_paid = parseFloat(parsedData.amount_paid) || 0;
    if (this.action === 'update' && parsedData.amount) {
        amount_paid = parsedData.amount;
    }

    return {
        loading : false,
        invoiceModalStatus : false,
        invoiceModalisOpen :false,
        createSupplierState : false,
        createClientState :false,
        hideSupplier : false,
        localData: parsedData,
        isIncoming: isIncoming,
        amount_paid : amount_paid,
        modalIsLoading : false,
        validationErrors: [],
        selectedFiles: [],
        paymentType: 'others',
        paymentMethods: [],
        loadingPaymentMethods: false,
        categories: [],
        loadingCategories: false,
        showNewCategoryInput: false,
        newCategoryName: '',
        creatingCategory: false,
        isDragging: false
    }
  },
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    canCreateCategories(){ return helper.checkAccess('create_payments') !== -1 },
    paymentCurrency(){
        return this.localData.invoice?.currency || this.localData.currency || this.business?.currency || '$'
    },
    total(){ return this.localData.products && this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.localData.products && this.localData.products.length ? this.localData.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
    balanceDue(){
        let total = parseFloat(this.localData.total) || parseFloat(this.localData.amount) || 0;
        let amountPaid = parseFloat(this.amount_paid) || 0;
        let paidSoFar = 0;
        
        if (this.localData.transactions && this.localData.transactions.length) {
            paidSoFar = this.localData.transactions.reduce((acc, t) => {
                // If editing a transaction, don't double count it
                if (this.action === 'update' && t.id === this.localData.id) return acc;
                if (t.status !== 'paid') return acc;
                return acc + (parseFloat(t.amount) || 0);
            }, 0);
        }
        
        return Math.max(0, total - (paidSoFar + amountPaid)).toFixed(2);
    },
    isProjectPayment() {
      return this.localData.paymentable_type === 'project'
    },
    activePaymentMethods(){
        // Filter only active payment methods or return the standard defaults
        const activeMethods = this.paymentMethods.filter(method => method.is_active)
        
        // Keep payment options available if the API cannot provide them
        if (activeMethods.length === 0) {
            return getDefaultPaymentMethods()
        }
        
        return activeMethods
    },
    modules() { return this.$store.getters.MODULES },
    isClientEnabled() {
        return this.modules.some(m => m.enabled && m.items.some(i => i.title === 'clients' && i.enabled))
    },
    isSupplierEnabled() {
        return this.modules.some(m => m.enabled && m.items.some(i => i.title === 'suppliers' && i.enabled))
    },
    hideTypeToggle() {
        return !!this.data?.hideTypeToggle;
    },
    isRequestedInvoicePaymentValid() {
        if (!this.localData.requested_invoice_status) return true

        const amount = Number(this.amount_paid) || 0
        const maximum = Number(this.localData.maximum_amount) || 0
        return amount > 0 && (maximum <= 0 || amount <= maximum)
    }
  },
  watch : {
    isIncoming(){
        const parsedData = this.data ? JSON.parse(JSON.stringify(this.data)) : {}
        if (!parsedData.payment_method) {
          parsedData.payment_method = ''
        }
        if (parsedData.category_id === undefined) {
          parsedData.category_id = null
        }
        if (parsedData.invoice) {
          if (parsedData.total === undefined || parsedData.total === null || parsedData.total === 0) {
            parsedData.total = parsedData.invoice.total;
          }
          if (!parsedData.transactions || parsedData.transactions.length === 0) {
            parsedData.transactions = parsedData.invoice.transactions;
          }
        }
        if (parsedData.supplierInvoice) {
          if (parsedData.total === undefined || parsedData.total === null || parsedData.total === 0) {
            parsedData.total = parsedData.supplierInvoice.total;
          }
          if (!parsedData.transactions || parsedData.transactions.length === 0) {
            parsedData.transactions = parsedData.supplierInvoice.transactions;
          }
        }
        if (this.action !== 'update') {
          parsedData.category_id = null
        }
        this.localData = parsedData
        this.categories = []
        this.showNewCategoryInput = false
        this.newCategoryName = ''
        this.modalIsLoading = true
        setTimeout(() => { this.modalIsLoading = false })
        this.fetchCategories()
    }
  },
  async mounted() {
    // Set initial payment type based on existing data
    if (this.localData.invoice_id || this.localData.supplier_invoice_id || this.localData.invoice || this.localData.supplierInvoice) {
      this.paymentType = 'invoice'
    } else if (this.localData.project_id || this.localData.project) {
      this.paymentType = 'project'
    } else {
      this.paymentType = 'others'
    }
    
    // Only new payments should be initialized with the configured default.
    // Existing payments must keep their persisted method when the edit modal opens.
    await Promise.all([
      this.fetchPaymentMethods(this.action !== 'update'),
      this.fetchCategories()
    ])
  },
  methods : {
    async fetchCategories() {
      this.loadingCategories = true
      try {
        const transactionType = this.isIncoming ? 'revenue' : 'expense'
        const response = await helper.customGet(`${process.env.VUE_APP_API}/transaction-categories?per_page=100&sort_field=name&sort_type=asc&type=${transactionType}`)
        if (transactionType !== (this.isIncoming ? 'revenue' : 'expense')) return
        this.categories = response.data.data || []
      } catch (error) {
        this.categories = []
      } finally {
        this.loadingCategories = false
      }
    },
    async createCategory() {
      if (this.creatingCategory || this.newCategoryName.length < 2) return

      this.creatingCategory = true
      try {
        const response = await helper.customPost(
          `${process.env.VUE_APP_API}/transaction-categories`,
          {
            name: this.newCategoryName,
            type: this.isIncoming ? 'revenue' : 'expense'
          },
          { showToast: true }
        )
        this.categories = [...this.categories, response.data].sort((a, b) => a.name.localeCompare(b.name))
        this.localData.category_id = response.data.id
        this.newCategoryName = ''
        this.showNewCategoryInput = false
      } catch (error) {
        this.validationErrors.push(error.message || this.$t('an_error_occurred'))
      } finally {
        this.creatingCategory = false
      }
    },
    async fetchPaymentMethods(forceDefault = false) {
      this.loadingPaymentMethods = true
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/payment-methods?per_page=100`)
        this.paymentMethods = response.data.data || []
        
        // If no payment methods exist, use the standard defaults
        if (this.paymentMethods.length === 0) {
          this.paymentMethods = getDefaultPaymentMethods()
        }
        
        // Wait for loading to complete before setting default
        this.loadingPaymentMethods = false
        
        // Set the default payment method if not already defined (check for empty string too) or if forced
        if (forceDefault || !this.localData.payment_method || this.localData.payment_method === '') {
          await this.$nextTick()
          
          const defaultMethod = this.paymentMethods.find(method => method.is_default === true)
          let defaultSlug = 'cash'
          
          if (defaultMethod) {
            defaultSlug = defaultMethod.slug
          } else {
            // If no default is set, use the first active payment method or 'cash'
            const firstActiveMethod = this.paymentMethods.find(method => method.is_active === true)
            defaultSlug = firstActiveMethod ? firstActiveMethod.slug : 'cash'
          }
          
          this.localData.payment_method = defaultSlug
          await this.$nextTick()
        }
      } catch (error) {
        // On error, keep the standard payment options available
        this.paymentMethods = getDefaultPaymentMethods()
        this.loadingPaymentMethods = false
        if (forceDefault || !this.localData.payment_method || this.localData.payment_method === '') {
          await this.$nextTick()
          this.localData.payment_method = 'cash'
        }
      }
    },
    async saveRow(){
        try {
            this.validationErrors = [];
            this.loading = true;
            this.localData.amount_paid = this.amount_paid;
            this.localData.is_incoming = this.isIncoming;
            this.localData.payment_type = this.paymentType;

            if (this.hidePaymentAssociations) {
                this.localData.status = 'paid';
                this.localData.due_date = null;
            }

            if (this.localData.date === 'Invalid date' || !this.localData.date) {
                this.localData.date = moment().format('YYYY-MM-DD');
            }
            if (this.localData.due_date === 'Invalid date') {
                this.localData.due_date = null;
            }

            if (!this.validateForm()) {
                this.loading = false;
                return;
            }

            const payload = {...this.localData}
            delete payload.maximum_amount
            delete payload.requested_invoice_status
            delete payload.lock_invoice_payment
            delete payload.lock_payment_amount

            // Create the transaction first
            const response = await helper.customPost(`${process.env.VUE_APP_API}/transactions`, payload, {showToast: true});
            
            // Upload attachments if any
            if (this.selectedFiles.length > 0 && response.data && response.data.id) {
                await this.uploadAttachments(response.data.id);
            }
            
            const refreshPayload = {
                payment: response.data,
                amountPaid: Number(this.amount_paid) || 0,
                invoiceId: this.localData.invoice_id || null
            }

            this.clearForm();
            this.loading = false;
            this.modalClosed();
            this.$emit('refresh', refreshPayload);
        } catch (error) {
            this.loading = false;
            this.validationErrors.push(error.message || this.$t('an_error_occurred'));
        }
    },
    async uploadAttachments(transactionId) {
        for (const file of this.selectedFiles) {
            try {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('entity_type', 'transaction');
                formData.append('entity_id', transactionId);
                
                await helper.customPost(`${process.env.VUE_APP_API}/attachments/upload`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } catch (error) {
                alert('Error uploading attachment:', error);
            }
        }
    },
    handleFileSelect(event) {
        const files = Array.from(event.target.files);
        this.selectedFiles = [...this.selectedFiles, ...files];
    },
    handleDrop(event) {
        this.isDragging = false;
        const files = Array.from(event.dataTransfer.files);
        this.selectedFiles = [...this.selectedFiles, ...files];
    },
    getFileIcon(filename) {
        const ext = filename.split('.').pop().toLowerCase();
        const iconMap = {
            pdf: 'bi bi-file-earmark-pdf-fill text-danger',
            doc: 'bi bi-file-earmark-word-fill text-primary',
            docx: 'bi bi-file-earmark-word-fill text-primary',
            xls: 'bi bi-file-earmark-excel-fill text-success',
            xlsx: 'bi bi-file-earmark-excel-fill text-success',
            csv: 'bi bi-file-earmark-spreadsheet-fill text-success',
            png: 'bi bi-file-earmark-image-fill text-info',
            jpg: 'bi bi-file-earmark-image-fill text-info',
            jpeg: 'bi bi-file-earmark-image-fill text-info',
            gif: 'bi bi-file-earmark-image-fill text-info',
            webp: 'bi bi-file-earmark-image-fill text-info',
            zip: 'bi bi-file-earmark-zip-fill text-warning',
            rar: 'bi bi-file-earmark-zip-fill text-warning',
            txt: 'bi bi-file-earmark-text-fill text-secondary',
        };
        return iconMap[ext] || 'bi bi-file-earmark-fill text-secondary';
    },
    removeFile(index) {
        this.selectedFiles.splice(index, 1);
        if (this.$refs.fileInput) {
            this.$refs.fileInput.value = '';
        }
    },
    formatFileSize(bytes) {
        if (!bytes) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },
    total_amount_paid(){    
        if(!this.localData.transactions || this.localData.transactions && !this.localData.transactions.length) return this.amount_paid
        return this.localData.transactions.map(transaction => transaction.amount).reduce((a,c) => { return a + c }) + parseFloat(this.amount_paid)
    },
    async updateRow(){
        try{
            this.validationErrors = [];
            this.loading = true
            if(!this.localData.supplier_id && this.localData.supplier && this.localData.supplier.id ){
                this.localData.supplier_id = this.localData.supplier.id
            }
            if(!this.localData.client_id && this.localData.client && this.localData.client.id ){
                this.localData.client_id = this.localData.client.id
            }

            this.localData.amount_paid = this.amount_paid
            this.localData.is_incoming = this.isIncoming
            this.localData.payment_type = this.paymentType

            if (this.localData.date === 'Invalid date' || !this.localData.date) {
                this.localData.date = moment().format('YYYY-MM-DD');
            }
            if (this.localData.due_date === 'Invalid date') {
                this.localData.due_date = null;
            }

            if (!this.validateForm()) {
                this.loading = false
                return
            }

            await helper.customPatch(`${process.env.VUE_APP_API}/transactions/${this.localData.id}`, {...this.localData }, {showToast: true})
            
            // Upload attachments if any
            if (this.selectedFiles.length > 0) {
                await this.uploadAttachments(this.localData.id);
            }
            
            this.loading = false
            this.clearForm()
            this.modalClosed()
            this.$emit('refresh',true)
        }catch(error){
            this.loading = false
            this.validationErrors.push(error.message || this.$t('an_error_occurred'));
        }
    },
    clearForm(){
        this.localData = {
            id : null,
            reference : '',
            client_id : null,
            client : {},
            date : '',
            total : 0,
            products : []
        }
        this.selectedFiles = []
        if (this.$refs.fileInput) {
            this.$refs.fileInput.value = ''
        }
    },
    addNewRow(){
        this.localData.products.push({
            id : null,
            label : '',
            quantity : 0,
            price : 0,
            discount : 0,
            vat :  this.business.vat,
            total : 0,
            sub_total : 0,
        })
    },
    calculatePrices(){
        this.$forceUpdate();
        for(let i = 0 ; i < this.localData.products.length ; i++){
            this.localData.products[i].total = parseFloat(this.localData.products[i].price) * parseFloat(this.localData.products[i].quantity)
            this.localData.products[i].sub_total = Math.round(parseFloat(this.localData.products[i].total))
            if(this.localData.products[i].vat > 0){
                this.localData.products[i].total += parseFloat((parseFloat(this.localData.products[i].total) * parseFloat(this.localData.products[i].vat/ 100)).toFixed(2))
                this.localData.products[i].total = Math.round(this.localData.products[i].total)
            }
        }
        this.localData.total = this.localData.products && this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
    },
    parseTTctoHt(index,price){
        if(price && price > 0){
           this.localData.products[index].price = ((price / this.localData.products[index].quantity) / 1.2).toFixed(2)
           this.localData.products[index].sub_total = parseFloat(this.localData.products[index].price) * parseFloat(this.localData.products[index].quantity)
        }
    },
    emitAutoComplete(data){
        this.localData.products[data.index] = {
            ...{
            inventory_id : data.result.id,
            product_id : data.result.product.id,
            label : data.result.product.label,
            product_label : data.result.product.label,
            // id : data.result.product.id,
            quantity : 0,
            maxQty : data.result.quantity,
            price : data.result.price,
            unity : data.result.unity,
            purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
            vat :  data.result.vat ? data.result.vat : this.business.vat,
            total : data.result.total ? data.result.total : 0,
            sub_total : data.result.sub_total ? data.result.sub_total : 0,
        }}
        this.localData.products = [...this.localData.products]
    },
    emitAutoCompleteSupplier(data){
        this.localData.supplier_id = data.result.id
        this.localData.supplier = data.result
        this.modalIsLoading = true
        setTimeout(() => { this.modalIsLoading = false })
    },
    openCreateSupplierModal(){
        this.createSupplierState = !this.createSupplierState
    },
    createSupplier(data){
        if(data.supplier){
            this.localData.supplier_id = data.supplier.id
            this.localData.supplier = data.supplier
        }
        if(data && data.state != undefined){
            this.createSupplierState = data.state
        }
    },
    emitAutoCompleteClient(data){
        this.localData.client_id = data.result.id
        this.localData.client = data.result
    },
    openCreateClientModal(){
        this.createClientState = !this.createClientState
    },
    checkIfValidProduct(){
        return this.localData.products.find(product => product.product_id != null) ? true : false
    },
    modalClosed(){
        this.isModalOpen = false 
        if(document.getElementById('close-modal-btn')){
            document.getElementById('close-modal-btn').click()
        }
        this.$emit('modalClosed', true)
    },
    emitAutoCompletePurchase(data){
        //purchase 
        this.localData.purchase_id = data.result.id
        this.localData.purchase = {
            reference : data.result.reference,
            id : data.result.id
        }
        //supplier
        this.localData.supplier = data.result.supplier
        this.localData.supplier_id = data?.result?.supplier?.id
        
        //total
        this.localData.total = data.result.total
        //transactions
        this.localData.transactions = data.result.transactions
        this.calculatePrices()
        this.modalIsLoading = true
        setTimeout(() => { this.modalIsLoading = false })
    },
    emitAutoCompleteOrder(data){
        this.localData.order_id = data.result.id

        //order
        this.localData.order = {
            reference : data.result.reference,
            id :data.result.id
        }

        //client
        this.localData.client = data.result.client
        this.localData.client_id = data?.result?.client?.id

        //total
        this.localData.total = data.result.total

        //transactions
        this.localData.transactions = data.result.transactions

        this.modalIsLoading = true
        setTimeout(() => { this.modalIsLoading = false })

    },
    emitAutoCompleteInvoice(data){
        //order 
        this.localData.order_id = data?.result?.order?.id
        this.localData.order = data?.result?.order

        //invoice
        this.localData.invoice = {
            reference : data.result.reference,
            date : data.result.date,
            id :data.result.id,
            status :data.result.status,
            currency: data.result.currency,
        }
        this.localData.currency = data.result.currency

        this.localData.invoice_id = this.localData?.invoice?.id
        //client
        this.localData.client = data.result.client
        this.localData.client_id = data?.result?.client?.id

        //total
        this.localData.total = data.result.total

        //transactions
        this.localData.transactions = data.result.transactions
        this.modalIsLoading = true
        setTimeout(() => { this.modalIsLoading = false })
    },
    emitAutoCompleteSupplierInvoice(data){

        //purchase 
        this.localData.purchase_id = data?.result?.purchase?.id
        this.localData.purchase = data?.result?.purchase

        //supplier
        this.localData.supplier = data.result.supplier
        this.localData.supplier_id = data?.result?.supplier?.id
        
        //invoice
        this.localData.supplierInvoice = {
            reference : data.result.reference,
            date : data.result.date,
            id :data.result.id,
            status :data.result.status,
        }
        this.localData.supplier_invoice_id = this.localData?.supplierInvoice?.id

        //total
        this.localData.total = data.result.total

        //transactions
        this.localData.transactions = data.result.transactions

        this.modalIsLoading = true
        setTimeout(() => { this.modalIsLoading = false })
    },
    emitAutoCompleteProject(data){
        this.localData.project_id = data.result.id
        this.localData.project = {
            name : data.result.name,
            id : data.result.id
        }
        this.modalIsLoading = true
        setTimeout(() => { this.modalIsLoading = false })
    },
    onPaymentTypeChange() {
      // Clear related fields when payment type changes
      if (this.paymentType !== 'invoice') {
        this.localData.invoice_id = null
        this.localData.invoice = null
        this.localData.supplier_invoice_id = null
        this.localData.supplierInvoice = null
      }
      if (this.paymentType !== 'project') {
        this.localData.project_id = null
        this.localData.project = null
      }
      this.modalIsLoading = true
      setTimeout(() => { this.modalIsLoading = false })
    },
    //helper functions
    formatDate(date,locale) { return helper.formatDate(date,locale) },
    formatMoney(number) { return helper.formatMoney(number, this.paymentCurrency);},
    formatReference(number,id) { return helper.formatReference(number,id);},
    validateForm() {
        this.validationErrors = [];
        
        if (!this.localData.date) {
            this.validationErrors.push(this.$t('date_is_required'));
        }
        
        if (!this.amount_paid || this.amount_paid <= 0) {
            this.validationErrors.push(this.$t('amount_must_be_greater_than_zero'));
        }
        
        const knownTotal = Number(this.localData.total) || 0;
        if (knownTotal > 0 && Number(this.amount_paid) > knownTotal) {
            this.validationErrors.push(this.$t('amount_cannot_exceed_total'));
        }
        
        return this.validationErrors.length === 0;
    },
  }
}
</script>

<style scoped>
    .payment-form {
        text-align: left;
    }

    .payment-fields--standalone > .payment-field {
        width: 100%;
    }

    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }

    .form-switch .form-check-input:checked {
            background-color: #0d6efd;
        }
        .toggle-label {
            font-weight: bold;
        }

.payment-type-toggle {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.toggle-container {
    display: flex;
    gap: 4px;
    position: relative;
}

.toggle-option {
    flex: 1;
    padding: 12px 24px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.3s ease;
    font-weight: 500;
    color: #6c757d;
}

.toggle-option i {
    font-size: 1.2rem;
}

.toggle-option.active {
    background: white;
    color: #0d6efd;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.toggle-option:first-child.active {
    background: #198754;
    color: #ffffff;
}

.toggle-option:first-child.active i {
    color: #ffffff;
}

.toggle-option:last-child.active {
    background: #dc3545;
    color: #ffffff;
}

.toggle-option:last-child.active i {
    color: #ffffff;
}

.toggle-option:hover:not(.active) {
    background: rgba(255,255,255,0.8);
}

.toggle-option:first-child i {
    color: #198754;
}

.toggle-option:last-child i {
    color: #dc3545;
}

/* Attachment Dropzone */
.attachment-dropzone {
    border: 1px dashed #ced4da;
    border-radius: 8px;
    padding: 9px 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #fafbfc;
}

.attachment-dropzone:hover {
    border-color: #0d6efd;
    background: rgba(13, 110, 253, 0.03);
}

.attachment-dropzone.dropzone-active {
    border-color: #0d6efd;
    background: rgba(13, 110, 253, 0.06);
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
}

.dropzone-content {
    display: flex;
    align-items: center;
    gap: 10px;
    pointer-events: none;
}

.dropzone-icon {
    font-size: 1.15rem;
    color: #6c757d;
    transition: color 0.2s ease;
}

.attachment-dropzone:hover .dropzone-icon,
.attachment-dropzone.dropzone-active .dropzone-icon {
    color: #0d6efd;
}

.dropzone-copy {
    display: flex;
    align-items: baseline;
    gap: 8px;
    min-width: 0;
    flex: 1;
}

.dropzone-title {
    font-weight: 500;
    color: #495057;
    font-size: 0.9rem;
    white-space: nowrap;
}

.upload-icon {
    color: #0d6efd;
    font-size: 1.1rem;
}

/* Attachment List */
.attachment-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 6px;
}

.attachment-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 10px;
    border-radius: 8px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    transition: all 0.2s ease;
}

.attachment-item:hover {
    background: #f0f1f3;
    border-color: #dee2e6;
}

.attachment-icon-wrapper {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: white;
    box-shadow: 0 1px 2px rgba(0,0,0,0.06);
    flex-shrink: 0;
}

.attachment-file-icon {
    font-size: 1rem;
}

.attachment-filename {
    font-size: 0.85rem;
    font-weight: 500;
    color: #212529;
    max-width: 280px;
}

.attachment-remove-btn {
    color: #adb5bd;
    padding: 4px 6px;
    border-radius: 6px;
    transition: all 0.2s ease;
}

.attachment-remove-btn:hover {
    color: #dc3545;
    background: rgba(220, 53, 69, 0.08);
}

@media (min-width: 768px) {
    .payment-fields--standalone > .payment-field {
        width: 50%;
    }
}

@media (min-width: 1200px) {
    .payment-fields--standalone > .payment-field {
        flex: 1 1 0;
        width: 0;
        min-width: 0;
    }
}

@media (max-width: 575.98px) {
    .dropzone-copy {
        display: block;
    }

    .dropzone-copy small {
        display: block;
        margin-top: 1px;
    }
}

input:disabled, select:disabled, .autocomplete-wrapper input:disabled {
    opacity: 0.5 !important;
    background-color: #e9ecef !important;
    cursor: not-allowed !important;
}
</style>
